import _classCallCheck from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web-client/web-client/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { getNullableType, isEnumType, isListType, isNonNullType, isScalarType } from "graphql";
import has from "lodash.has";
import mapValues from "lodash.mapvalues";
import omit from "lodash.omit";
import { isNone } from "./is-none";
import { mapIfArray } from "./map-if-array";
export var Serializer = /*#__PURE__*/function () {
  function Serializer(schema, functionsMap, removeTypenameFromInputs, nullFunctions) {
    _classCallCheck(this, Serializer);

    this.schema = schema;
    this.functionsMap = functionsMap;
    this.removeTypenameFromInputs = removeTypenameFromInputs;
    this.nullFunctions = nullFunctions;
  }

  _createClass(Serializer, [{
    key: "serialize",
    value: function serialize(value, type) {
      if (isNonNullType(type)) {
        return this.serializeInternal(value, getNullableType(type));
      } else {
        return this.serializeNullable(value, getNullableType(type));
      }
    }
  }, {
    key: "serializeNullable",
    value: function serializeNullable(value, type) {
      return this.nullFunctions.serialize(this.serializeInternal(value, type));
    }
  }, {
    key: "serializeInternal",
    value: function serializeInternal(value, type) {
      var _this = this;

      if (isNone(value)) {
        return value;
      }

      if (isScalarType(type) || isEnumType(type)) {
        return this.serializeLeaf(value, type);
      }

      if (isListType(type)) {
        return mapIfArray(value, function (v) {
          return _this.serialize(v, type.ofType);
        });
      }

      return this.serializeInputObject(value, type);
    }
  }, {
    key: "serializeLeaf",
    value: function serializeLeaf(value, type) {
      var fns = this.functionsMap[type.name] || type;
      return fns.serialize(value);
    }
  }, {
    key: "serializeInputObject",
    value: function serializeInputObject(givenValue, type) {
      var _this2 = this;

      var value = this.removeTypenameFromInputs && has(givenValue, "__typename") ? omit(givenValue, "__typename") : givenValue;
      var fields = type.getFields();
      return mapValues(value, function (v, key) {
        var f = fields[key];
        return f ? _this2.serialize(v, f.type) : v;
      });
    }
  }]);

  return Serializer;
}();